import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    stocks: [],
};

const getters = {
    stocks: state => state.stocks,

    stockSelector() {
        return state.stocks.map(stock => {
            return {
                stock_id: stock.id,
                stock: stock,
                code: stock.code,
                name: stock.name,
                total_quantity: null,
                equivalent_total_quantity: null,
                supplier_price: null,
                total_cost: null,
                equivalent_quantity_after: null,
                type: stock.type,
            };
        });
    },
};

const mutations = {
    setStocks(state, data) {
        state.stocks = data;
    },
};

const actions = {
    async getStockList({ commit, dispatch }, params = {}) {
        const url = Laroute.route('inventory.fnb.stock.selector');

        const options = {
            params: Object.assign(
                {
                    query: null,
                    limit: 15,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-stocks');

        try {
            const { data } = await axios.get(url, options);

            endLoading(dispatch, 'fetch-stocks');
            commit('setStocks', data);

            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-stocks');
            throw e;
        }
    },

    async show({ dispatch }, { id, endProduct = false }) {
        const url = Laroute.route('inventory.fnb.stock.show', {
            id,
            endProduct,
        });

        startLoading(dispatch, 'show-stock');

        try {
            const { data } = await axios.get(url);
            endLoading(dispatch, 'show-stock');
            return data;
        } catch (e) {
            endLoading(dispatch, 'show-stock');
            throw e;
        }
    },

    async update({ dispatch }, payload) {
        const url = Laroute.route('inventory.fnb.stock.update');

        startLoading(dispatch, 'update-stock');

        try {
            const { data } = await axios.put(url, payload);
            endLoading(dispatch, 'update-stock');
            return data;
        } catch (e) {
            endLoading(dispatch, 'update-stock');
            throw e;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/inventory-fnb/modules/stock.js